import { useState, useEffect } from 'react';
import { fetchPopularPosts } from '../services/api';

export const usePopularPosts = (limit = 5) => {
  const [popularPosts, setPopularPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const posts = await fetchPopularPosts(limit);
      setPopularPosts(posts);
    } catch (err) {
      console.error('Erreur chargement articles populaires :', err);
      setError(err.message || 'Erreur lors du chargement des articles populaires.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [limit]);

  return {
    popularPosts,
    loading,
    error,
    refetch: fetchData
  };
};
